module.exports = __webpack_public_path__ + "static/media/Oman.9b63361b.png";